const riot = require('riot');
import '../components/apistats.tag'
riot.tag2('page-apistat', '<apistats></apistats>', '', '', function(opts) {
});

